import React from 'react';
import { Box, Alert, Chip } from '@mui/material';
import { StyledCard, StyledCardContent } from '../styles/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { StyledTypography, StyledHeading } from '../styles/styles';
import { StyledButton } from '../styles/StyledButtons';
import { InvestmentEntity } from '../../models/InvestmentEntity';
import Investor from '../../models/Investor';

interface AssociationCompleteStepProps {
  entity: InvestmentEntity | null;
  investor: Investor | null;
  onComplete: () => void;
}

export const AssociationCompleteStep: React.FC<AssociationCompleteStepProps> = ({
  entity,
  investor,
  onComplete,
}) => {
  const getEntityTypeLabel = (type: string) => {
    const labels: Record<string, string> = {
      INDIVIDUAL: 'Individual',
      TRUST: 'Trust',
      COMPANY: 'Company',
      FUND: 'Fund',
      PARTNERSHIP: 'Partnership',
      OTHER: 'Other',
    };
    return labels[type] || type;
  };

  return (
    <StyledCard tone="tone1">
      <StyledCardContent sx={{ py: 2, textAlign: 'center' }}>
        <Box sx={{ mb: 2 }}>
          <CheckCircleIcon
            sx={{
              fontSize: 48,
              color: 'success.main',
              mb: 1,
            }}
          />
          <StyledHeading sx={{ mb: 1 }}>Association Complete!</StyledHeading>
        </Box>

        <Alert severity="success" sx={{ mb: 2, textAlign: 'left' }}>
          <StyledTypography sx={{ fontWeight: 600, mb: 0.5 }}>
            Successfully Associated Investment Entity
          </StyledTypography>
          <StyledTypography>
            {investor?.name} is now associated with the investment entity "{entity?.name}".
          </StyledTypography>
        </Alert>

        {entity && (
          <Box
            sx={{
              border: 1,
              borderColor: 'divider',
              borderRadius: 1,
              p: 2,
              mb: 2,
              textAlign: 'left',
            }}
          >
            <StyledHeading headerVariant="heading2" sx={{ mb: 1 }}>
              Entity Details
            </StyledHeading>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <StyledTypography variant="body1" sx={{ fontWeight: 600 }}>
                {entity.name}
              </StyledTypography>
              <Chip label={getEntityTypeLabel(entity.type)} size="small" variant="outlined" />
            </Box>

            {entity.description && (
              <StyledTypography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {entity.description}
              </StyledTypography>
            )}
          </Box>
        )}

        <StyledButton variant="contained" size="medium" onClick={onComplete}>
          Return to Dashboard
        </StyledButton>
      </StyledCardContent>
    </StyledCard>
  );
};
